import { injectable } from 'inversify';
import { Vue } from 'vue-property-decorator';
import * as Api from "@/app/interaction/api";
import { queryElements, replaceWithElement } from '@/app/shared/utils/content-utils';
import { createInteractionComponent } from '@/app/interaction/ui'
import { BlockFileContent, BlockFileState } from './block-file-interfaces';

@injectable()
export class IncludeBlockFilesHandler implements Api.IncludeComponentsHandlerInterface {
  
  public async includeComponents($parsedContent: any): Promise<Vue[]> {
    const elements: any = queryElements('.file.component', $parsedContent);
    if (elements === null) {
      return []
    }

    let components = []
    for (const element of elements) {
      const $element: any = $(element);
      const component = this.includeComponent($element);
      components.push(component)
    }

    return components
  }

  private includeComponent($element: any): Vue {
    const id: string = $element.attr('id');
    const mimeType: string = $element.attr('data-mimetype');
    const title: string = $('.file__title', $element).text();
    const description: string = $('.file__description', $element).text();
    const size: string = $('.file__size', $element).text();
    const uri: string = $('.file__view a', $element).attr('href') as string;
    const originalFilename: string = $('.file__download a', $element).attr('download') as string;

    const interactionComponent = createInteractionComponent<BlockFileContent, BlockFileState>(id, 'block-file', {
      title,
      instruction: null
    }, {
      mimeType, description, size, uri, originalFilename
    })
    interactionComponent.$mount();

    replaceWithElement(`#${id}`, interactionComponent.$el);

    return interactionComponent
  }
}
